import React from 'react'
import PageAnimation from '@shared/components/page-animation'

import { SignFormSection } from './sections/sign-form-section'

export const View = () => (
	<PageAnimation>
		<SignFormSection />
	</PageAnimation>
)
